import { makeRequest } from '@/libs/RequestModule'
import { getEnv } from '@/libs/Environment.js'
import router from '@/router/index.js'
import store from '@/store/index.js'

const startUp = function (afterLogin = false) {
    (async () => {
        await router.isReady()
        const atLoginPage = router.currentRoute.value.name === 'login'
        let routines = [
            { route: 'baseInfo', setter: 'setBaseInfoList' },
            { route: 'getMenuVisibility', setter: 'setUserAccess' },
            { route: 'getfilhos', setter: 'setDependents' },
            { route: 'getCards', setter: 'setCards' },
            { route: 'getRetailSpecificParams', setter: 'setRetailSpecificParams' }
        ]
        if (atLoginPage && !afterLogin) {
            routines = [routines[0]]
        }
        if (afterLogin) {
            routines.shift()
        }
        for (const routine of routines) {
            let routineRes = null

            if (routine.route !== 'baseInfo' || (routine.route === 'baseInfo' && getEnv().usa_instituicao_cliente_filial === 'N')) {
                if (routine.action) {
                    routineRes = await routine.action(routine.params)
                } else if (routine.route) {
                    routineRes = await makeRequest(routine.route)
                }

                if (routine.setter) {
                    await store.dispatch(routine.setter, routineRes?.data)
                }
            }
        }
    })()
}

export { startUp }
